import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "a post about this",
  "description": "",
  "published": "2012-06-15T00:00:00.000Z",
  "redirect_from": ["/blog/?p=4660"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`immediately`}</p>
    <p><a parentName="p" {...{
        "href": "http://news.ycombinator.com/threads?id=Swizec"
      }}>{`http://news.ycombinator.com/threads?id=Swizec`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      